/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Filter by one or more anatomical districts.
 * @export
 * @enum {string}
 */
export enum EnMetricDistrict {
    ANKLE = 'ANKLE',
    UPPERARM = 'UPPER_ARM',
    LOWERARM = 'LOWER_ARM',
    SHOULDERWIDTH = 'SHOULDER_WIDTH',
    TRUNK = 'TRUNK',
    WAIST = 'WAIST',
    UPPERLEG = 'UPPER_LEG',
    LOWERLEG = 'LOWER_LEG',
    BODY = 'BODY'
}

